Copyright © 2022-{{currentYear}},
@if (showStrong) {
  <strong>Applied Particle Technology</strong>
}
@if (!showStrong) {
  Applied Particle Technology
}
.{{ 'All rights reserved' | translate }}
